/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import Icon from '@mui/icons-material/DeleteOutline';
import { useTheme } from 'styled-components';
import { IconButton, styleIcon } from './IconButton';
import { IconButtonProps } from './types';

const StyledIcon = styleIcon(Icon);

export const DeleteIconButton = ({
    disabled,
    iconColor,
    ...rest
}: IconButtonProps) => {
    const theme = useTheme();
    return (
        <IconButton disabled={disabled} {...rest}>
            <StyledIcon
                data-test-id='DeleteOutlineIcon'
                disabled={disabled}
                iconColor={iconColor || theme.color('alert')}
            />
        </IconButton>
    );
};
